var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBell = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 1.89286C12.0334 1.89286 11.0783 2.58555 10.7342 3.67857H15.266C14.922 2.58555 13.9669 1.89286 13.0001 1.89286ZM16.2543 3.67857C15.8813 2.13819 14.5658 1 13.0001 1C11.4345 1 10.119 2.13819 9.74599 3.67857C9.67689 3.96395 9.64014 4.26313 9.64014 4.57143H16.3601C16.3601 4.26313 16.3234 3.96395 16.2543 3.67857Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4799 25.1071C14.1905 25.1071 14.811 24.748 15.143 24.2143H11.8167C12.1487 24.748 12.7692 25.1071 13.4799 25.1071ZM10.7637 24.2143C11.1591 25.2546 12.2259 26 13.4799 26C14.7338 26 15.8006 25.2546 16.196 24.2143C16.3021 23.935 16.3599 23.6345 16.3599 23.3214H10.5999C10.5999 23.6345 10.6576 23.935 10.7637 24.2143Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6 20.6429H3.4C2.60471 20.6429 1.96 21.2425 1.96 21.9821C1.96 22.7218 2.60471 23.3214 3.4 23.3214H22.6C23.3953 23.3214 24.04 22.7218 24.04 21.9821C24.04 21.2425 23.3953 20.6429 22.6 20.6429ZM3.4 19.75C2.07452 19.75 1 20.7494 1 21.9821C1 23.2149 2.07452 24.2143 3.4 24.2143H22.6C23.9255 24.2143 25 23.2149 25 21.9821C25 20.7494 23.9255 19.75 22.6 19.75H3.4Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1604 19.7501V12.1609C21.1604 7.96941 17.507 4.57157 13.0004 4.57157C8.49373 4.57157 4.84037 7.96941 4.84037 12.1609V19.7501H21.1604ZM13.0004 3.67871C7.96353 3.67871 3.88037 7.4763 3.88037 12.1609V20.643H22.1204V12.1609C22.1204 7.4763 18.0372 3.67871 13.0004 3.67871Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.a561e833.svg";
export { ForwardRef as ReactComponent };